$(function () {
  // 客户端状态初始化
  // 初始化命名空间
  window.litime = {
    debounce,
    throttle,
    showLoading,
    hideLoading,
    openChatApp,
    disableScroll,
    enableScroll,
    i18n: {}, // 添加 i18n 对象
    initWhenVisible,
  };
});
function initWhenVisible(options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: `0px 0px ${threshold}px 0px` }
  );

  observer.observe(options.element);
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}
// 锚点跳转 传递 自定义class 名称
function anchorJumpFunction(element) {
  // 处理锚点跳转
  const $jumpPoints = element.find('[data-jump]');
  $jumpPoints.on('click', (event) => {
    const $block = $(event.currentTarget);
    // 获取当前点击元素的 data-jump 属性值
    const dataPoint = $block.data('jump');
    // 根据 data-jump 获取对应的 marker-point 元素
    const $markerPoint = $('[data-point="' + dataPoint + '"]');
    // 如果找到了对应的 marker-point 元素，则滚动到该元素
    if ($markerPoint.length) {
      $('html, body').animate(
        {
          scrollTop: $markerPoint.offset().top,
        },
        500
      );
    }
  });
}
/**
 * 为元素添加唯一事件监听器
 * @param {HTMLElement} element - 需要绑定事件的元素
 * @param {string} eventType - 事件类型，如 'click'
 * @param {Function} handler - 事件处理函数
 * 使用方式
 * customEventListener(button, 'click', () => {
      
    });
 */
function customEventListener(element, eventType, handler) {
  if (element && !element._eventListeners) {
    //
    element._eventListeners = {};
  }

  if (element && !element._eventListeners[eventType]) {
    element.addEventListener(eventType, handler);
    element._eventListeners[eventType] = handler; // 记录已绑定事件
  }
}

/**
 * 格式化价格
 * @param {number} cents - 需要格式化的价格
 * @param {string} format - 格式化字符串
 * @returns {string} 格式化后的价格
 * 使用方式
 * Shopify.formatMoney(100, '{{ shop.money_format }}');
 */
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// 防抖函数
function debounce(fn, delay = 300) {
  let timer = null;

  return function (...args) {
    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

// 节流函数
function throttle(fn, delay = 300) {
  let timer = null;

  return function (...args) {
    if (timer) return;

    timer = setTimeout(() => {
      fn.apply(this, args);
      timer = null;
    }, delay);
  };
}

function showLoading() {
  $('.global-loading_wrapper').addClass('flex').removeClass('hidden');
  window.litime.disableScroll();
}

function hideLoading() {
  $('.global-loading_wrapper').removeClass('flex').addClass('hidden');
  window.litime.enableScroll();
}
async function getCartDrawer(triggerElement = null) {
  // 获取购物车抽屉元素
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    // document.querySelector('.empty-cart-drawer').classList.remove('hidden');
    // document.querySelector('.cart-drawer-content').classList.add('hidden');
    // document.querySelector('.bottom-drawer-container').classList.add('hidden');
    // 打开购物车抽屉，如果有触发元素就传入
    cartDrawer.open(triggerElement);
    // 更新购物车内容
    await cartDrawer.getCartContent();
  }
}

// 添加全局遮罩层管理
window.overlayManager = {
  $overlay: null,
  currentType: null, // 添加当前遮罩层类型标记

  show(type = 'drawer') {
    // 先移除所有可能存在的遮罩层
    $('.overlay-mask, .drawer-overlay-mask').remove();

    // 设置当前类型
    this.currentType = type;
    const scrollbarWidth = getScrollbarWidth();

    window.litime.disableScroll();

    // 根据类型创建不同的遮罩层
    if (type === 'header') {
      this.$overlay = $('<div></div>')
        .addClass('overlay-mask')
        .css({
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 99,
          marginLeft: `-${scrollbarWidth}px`,
        });
    } else if (type === 'header-search') {
      this.$overlay = $('<div></div>')
        .addClass('search-overlay-mask')
        .css({
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 99,
          marginLeft: `-${scrollbarWidth}px`,
        });
    } else {
      this.$overlay = $('<div></div>')
        .addClass('drawer-overlay-mask')
        .css({
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 800,
          marginLeft: `-${scrollbarWidth}px`,
        });
    }

    $('#MainContent').append(this.$overlay);
    return this.$overlay;
  },

  hide(type = 'drawer') {
    // 只有当要隐藏的类型与当前显示的类型相同时才执行隐藏
    if (type === this.currentType) {
      if (this.$overlay) {
        this.$overlay.remove();
        this.$overlay = null;
      }
      // 只移除对应类型的遮罩层
      if (type === 'header') {
        $('.overlay-mask').remove();
      } else if (type === 'header-search') {
        $('.search-overlay-mask').remove();
      } else {
        $('.drawer-overlay-mask').remove();
      }
      window.litime.enableScroll();

      this.currentType = null;
    }
  },

  get() {
    return this.$overlay;
  },
};

function openChatApp() {
  const chatApp = document.querySelector('#ShopifyChat');
  if (chatApp) {
    const shadowRoot = chatApp.shadowRoot;
    const button = shadowRoot.querySelector('button');
    button.click();
  }
}

// 添加获取滚动条宽度的函数
function getScrollbarWidth() {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
}
// 添加禁用滚动条的方法
function disableScroll() {
  const scrollbarWidth = getScrollbarWidth();
  document.body.style.overflow = 'hidden';
  document.body.style.paddingRight = `${scrollbarWidth}px`;

  // 处理固定定位的元素
  document.querySelectorAll('.fixed-header, .fixed-element').forEach((el) => {
    el.style.paddingRight = `${scrollbarWidth}px`;
  });
}
// 添加恢复滚动条的方法
function enableScroll() {
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';

  // 处理固定定位的元素
  document.querySelectorAll('.fixed-header, .fixed-element').forEach((el) => {
    el.style.paddingRight = '';
  });
}
// 正则校验

const ltUtils = {
  rule: {
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/, //邮箱规则：任何值
    password_confirmation: /^.{6,}$/,
    password: /^.{6,}$/,
    any_value: /^.+$/, //规则: 任何值
  },
};
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// 解析和更新购物车相关组件
async function updateCartComponents(cartContent) {
  if (!cartContent?.sections) return;

  const parser = new DOMParser();

  // 更新购物车抽屉
  if (cartContent.sections['cart-drawer']) {
    const doc = parser.parseFromString(cartContent.sections['cart-drawer'], 'text/html');
    const cartDrawer = document.querySelector('cart-drawer');
    const cartDrawerContent = doc.querySelector('cart-drawer');
    if (cartDrawer && cartDrawerContent) {
      cartDrawer.innerHTML = cartDrawerContent.innerHTML;
      cartDrawer.bindRemoveButtons(); // 先重新绑定删除按钮事件
      cartDrawer.init(); // 然后初始化其他功能
    }
  }

  // 更新购物车图标
  if (cartContent.sections['cart-icon-bubble']) {
    const iconDoc = parser.parseFromString(cartContent.sections['cart-icon-bubble'], 'text/html');
    const iconBubble = document.querySelector('cart-icon-bubble');
    if (iconBubble) {
      iconBubble.innerHTML = iconDoc.querySelector('cart-icon-bubble').innerHTML;
    }
  }
}
